/*var repair_values = [
  {
    os: "Apple iPhone",
    model: "iPhone SE",
    service: ['49.90', '49.90', '59.90', '59.90', '49.90', '59.90', '49.90', '39.90', '59.90', '49.90', '59.90', '59.90', '59.90']
  }, {
    os: "Apple iPhone",
    model: "iPhone 6S",
    service: ['64.90', '49.90', '64.90', '64.90', '64.90', '64.90', '64.90', '34.90', '64.90', '64.90', '64.90', '64.90', '74.90']
  }, {
    os: "Apple iPhone",
    model: "iPhone 6S Plus",
    service: ['64.90', '49.90', '64.90', '64.90', '64.90', '64.90', '64.90', '34.90', '64.90', '64.90', '64.90', '64.90', '74.90']
  }, {
    os: "Apple iPhone",
    model: "iPhone 7",
    service: ['74.90', '59.90', '74.90', '74.90', '89.90', '99.90', '74.90', '34.90', '74.90', '74.90', '74.90', '74.90','99.90']
  },{
    os: "Apple iPhone",
    model: "iPhone 7 Plus",
    service: ['74.90', '59.90', '74.90', '74.90', '74.90', '139.90', '74.90', '39.90', '74.90', '74.90', '74.90', '74.90', '109.90']
  },{
    os: "Apple iPhone",
    model: "iPhone 8",
    service: ['74.90', '59.90', '74.90', '74.90', '74.90', '139.90', '74.90', '34.90', '74.90', '74.90', '74.90', '74.90', '109.90']
  },{
    os: "Apple iPhone",
    model: "iPhone 8 Plus",
    service: ['74.90', '59.90', '74.90', '74.90', '74.90', '139.90', '74.90', '34.90', '74.90', '74.90', '74.90', '74.90', '129.90']
  },{
    os: "Apple iPhone",
    model: "iPhone X",
    service: ['89.90', '89.90', '89.90', '89.90', '74.90', '139.90', '89.90', '54.90', '89.90', '89.90', '89.90', '89.90', '199.90']
  },{
    os: "Apple iPhone",
    model: "iPhone XR",
    service: ['89.90', '99.90', '89.90', '89.90','89.90', '139.90', '89.90', '54.90', '89.90', '89.90', '89.90', '89.90', '189.90']
  },{
    os: "Apple iPhone",
    model: "iPhone XS",
    service: ['99.90', '99.90', '99.90', '99.90', '89.90', '139.90', '99.90', '54.90', '99.90', '99.90','99.90', '99.90', '249.90']
  },{
    os: "Apple iPhone",
    model: "iPhone XS Max",
    service: ['99.90', '99.90', '99.90', '99.90', '89.90', '139.90', '99.90', '54.90', '99.90', '99.90', '99.90', '99.90', '269.90']
  },
  {
    os: "Apple iPhone",
    model: "iPhone 11",
    service: ['99.90', '99.90', '99.90', '99.90', '89.90', '139.90', '99.90', '54.90', '99.90', '99.90', '99.90', '99.90', '199.90']
  },
  {
    os: "Apple iPhone",
    model: "iPhone 11 Pro",
    service: ['99.90', '99.90', '99.90', '99.90', '99.90', '149.90', '99.90', '64.90', '99.90', '99.90', '99.90', '99.90', '279.90']

  },
  {
    os: "Apple iPhone",
    model: "iPhone 11 Pro Max",
    service: ['119.90', '99.90', '99.90', '99.90', '99.90', '149.90', '99.90', '64.90', '99.90', '99.90', '99.90', '99.90', '289.90']

  }
  
];*/

var repair_values = [
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone SE",
    service: ['39.90', '29.90', '39.90', '39.90', '39.90', '39.90', '39.90', '29.90', '34.90', '39.90', '39.90', '39.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar'],
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 6",
    service: ['24.90', '29.90', '49.90', '29.90', '49.90', '29.90', '49.90', '24.90','49.90', '29.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 6 Plus",
    service: ['24.90', '29.90', '49.90', '29.90', '49.90', '29.90', '49.90', '24.90','54.90', '29.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar']
  },  
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 6S",
    service: ['24.90', '29.90', '49.90', '29.90', '49.90', '29.90', '49.90', '24.90','49.90', '29.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar']
  },  
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 6S Plus",
    service: ['24.90', '29.90', '49.90', '29.90', '49.90', '29.90', '49.90', '24.90','54.90', '29.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar']
  },  
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 7",
    service: ['39.90', '39.90', '49.90', '39.90', '69.90', '39.90', '49.90', '29.90','59.90', '39.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone', 'Botão Ligar/Desligar']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 7 Plus",
    service: ['39.90', '39.90', '49.90', '39.90', '69.90', '39.90', '49.90', '29.90','69.90', '39.90', '49.90', '49.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone', 'Botão Ligar/Desligar']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 8",
    service: ['39.90', '39.90', '59.90', '39.90', '69.90', '39.90', '59.90', '29.90','79.90', '49.90', '59.90', '59.90','99.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar', 'Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 8 Plus",
    service: ['44.90', '44.90', '59.90', '44.90', '69.90', '44.90', '59.90', '29.90','89.90', '49.90', '59.90', '59.90','99.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Frontal','Câmara Traseira','Motor Vibratório','Coluna de Som','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone X",
    service: ['69.90', '54.90', '74.90', '69.90', '79.90', '69.90', '74.90', '34.90','109.90', '69.90', '74.90', '74.90','119.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone XR",
    service: ['69.90', '54.90', '74.90', '69.90', '79.90', '69.90', '74.90', '34.90','119.90', '69.90', '74.90', '74.90','119.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone XS",
    service: ['79.90', '59.90', '84.90', '79.90', '79.90', '79.90', '84.90', '34.90','129.90', '79.90', '84.90', '84.90','129.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone XS Max",
    service: ['79.90', '59.90', '84.90', '79.90', '79.90', '79.90', '84.90', '34.90','139.90', '79.90', '84.90', '84.90','129.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone SE 2020",
    service: ['44.90', '39.90', '59.90', '44.90', '69.90', '44.90', '59.90', '29.90','89.90', '44.90', '59.90', '59.90','99.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 11",
    service: ['79.90', '59.90', '84.90', '79.90', '84.90', '84.90', '84.90', '34.90','139.90', '79.90', '84.90', '84.90','139.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 11 Pro",
    service: ['79.90', '69.90', '89.90', '89.90', '99.90', '89.90', '89.90', '59.90','169.90', '79.90', '89.90', '89.90','139.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 11 Pro Max",
    service: ['89.90', '69.90', '89.90', '89.90', '99.90', '89.90', '89.90', '59.90','179.90', '89.90', '89.90', '89.90','139.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 12 Mini",
    service: ['89.90', '74.90', '89.90', '89.90', '89.90', '89.90', '89.90', '39.90', '179.90', '89.90', '89.90', '89.90','149.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 12",
    service: ['89.90', '79.90', '89.90', '89.90', '89.90', '89.90', '89.90', '39.90', '199.90', '89.90', '89.90', '89.90','149.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 12 Pro",
    service:['89.90', '79.90', '89.90', '89.90', '99.90', '89.90', '89.90', '39.90', '209.90', '89.90', '89.90', '89.90','149.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 12 Pro Max",
    service: ['89.90', '79.90', '89.90', '89.90', '99.90', '89.90', '89.90', '39.90', '219.90', '89.90', '89.90', '89.90','149.90'],
    repair_services : ['Auscultador','Bateria','Botão Volume','Câmara Traseira','Motor Vibratório','Coluna de Som','Câmara Frontal','Lente Câmara Traseira','Vidro LCD','Porta de Ligação','Microfone','Botão Ligar/Desligar','Vidro da Capa Traseira']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 13 Mini",
    service: ['249.90'],
    repair_services : ['Vidro LCD']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 13",
    service: ['249.90'],
    repair_services : ['Vidro LCD']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 13 Pro",
    service: ['339.90'],
    repair_services : ['Vidro LCD']
  },
  {
    os : "Apple",
    device : "iPhone",
    model: "iPhone 13 Pro Max",
    service: ['369.90'],
    repair_services : ['Vidro LCD']
  }
];

var repair_services_details = {
  "Bateria": [" Equipamento lento ou sem resposta","Não desliga","Não liga","Encerra ou reinicia espontaneamente","Dificuldades no arranque","Aplicações ou sistema sem resposta","Descarrega demasiado rápido", "Bateria inchada"],
  "Vidro LCD": ["Vidro partido ou rachado","Ecrã com linhas verticais, horizontais ou manchas","Ecrã intermitente"," Ecrã escuro","Ecrã tátil descalibrado","Imagem a preto e branco","Imagem do ecrã distorcida ou com qualidade reduzida"],
  "Vidro da Capa Traseira": ["Vidro traseiro rachado","Vidro traseiro partido"],
  "Câmara Frontal": ["Câmara não liga","Fotografias desfocadas, com sinais vermelhos ou manchas","Câmara não reconhecida em vídeo chamadas","Não é possível mudar do modo vertical para horizontal","Brilho do ecrã não ajusta em função da iluminação local"],
  "Câmara Traseira": ["Câmara não liga","Câmara não é reconhecida em videochamadas","Flash da câmara deixa de funcionar","Fotografias desfocadas","Fotografias com sinais vermelhos ou manchas"],
  "Lente Câmara Traseira": ["Lente da câmara da traseira partida","Lente da câmara traseira rachada"],
  "Motor Vibratório": ["Vibração deixa de funcionar","Vibração invulgar"],
  "Microfone": ["Dificuldade em ouvir durante a chamada","O recetor da chamada ouve com ruído","Gravações de áudio com ruído"],
  "Auscultador": ["Dificuldade em ouvir durante as chamadas","Ruído no som que ouve quando está em chamada"],
  "Coluna de Som": ["Microfone não funciona","Não é possível ouvir do auscultador ou das colunas","Equipamento bloqueado  no modo 'auscultadores'","Ruído invulgar","Notificações ou alertas sem som"],
  "Botão Volume": ["Não é possível bloquear ou desbloquear","Não é possível alternar entre o modo sem som ou com som","Não é possível realizar a capturas de ecrã","Não é possível controlar o volume do equipamento"],
  "Botão Ligar/Desligar": ["Não é possível bloquear ou desbloquear","Não é possível ligar ou desligar o smartphone","Não é possível realizar a capturas de ecrã"],
  "Porta de Ligação": ["Equipamento não recebe energia","Não carrega"," Adaptador de corrente não funciona","Sinais de corrosão na porta de ligação ","Ausência do som de toque em chamadas","Problemas com os auscultadores ou com a entrada dos auscultadores"]
}


// var repair_services = ['Antena', 'Auscultador', 'Bateria', 'Botão Volume/Mute/Power', 'Câmara Frontal/ Sensor de proximidade', 'Câmara Traseira', 'Carregamento Wireless', 'Motor Vibratório', 'Porta de ligação/Saída de áudio', 'Vidro Câmara Traseira', 'Vidro LCD']



var repair_services = ['Auscultador',
                       'Bateria',
                       'Botão Ligar/Desligar',
                       'Botão Volume',
                       'Câmara Frontal',
                       'Câmara Traseira',
                       'Coluna de Som',
                       'Lente Câmara Traseira',
                       'Microfone',
                       'Motor Vibratório',
                       'Porta de Ligação',
                       'Sensor Proximidade',
                       'Vidro LCD'];

$(document).ready(function () {

  $("#rep-model-type").change(function () {
    var model = $(this).val();
    var service = get_services(model);
    $('.select-modal').html(model);
    //     $("#rep-service-type").html(service);
    $("#rep-price").html("");
    $('.problems_text').html(`<ul>
<li>Equipamento lento ou
sem respost</li>
<li>Não deslig</li>
<li>Não lig</li>
<li>Encerra ou reinicia
espontanemant</li>
<li>Dificuldades no
arranqu</li>
<li>Aplicações ou sistema
sem respost</li>
<li>Descarrega demasiado
rápid</li>
<li>Bateria inchada</li>
</ul>`).css('opacity', '0');
    $("#rep-name, .line_bar, #rep-price").css('opacity', '0');
    $('.iphone_reparacao-div').addClass('disable').removeClass('active');
    for(var i = 0; i < repair_values.length; i++) {
      if(repair_values[i].model == model) {
        for(var j = 0; j < repair_values[i].repair_services.length; j++) {
          if(repair_values[i].repair_services != "-"){
            $('.iphone_reparacao-div[data-title="'+repair_values[i].repair_services[j]+'"] input[type="radio"]').attr('data-price', repair_values[i].service[j]);
            $('.iphone_reparacao-div[data-title="'+repair_values[i].repair_services[j]+'"]').removeClass('disable');
          }
        }
      }  
    }

  });


  //function to get repair modes
  $('#rep_zipcode, #rep_zipcode_delivery').focusout(function(e) {
    e.preventDefault();
    var value = $(this).val();  
    if (value == '') {
      return false;
    }  
    var URI = "https://core-qa.herokuapp.com/v1/TimeWindows?zipCode="+ value;

    $.ajax({
      url: URI,
      type: 'GET',
      success: function (result,status,xhr) {
        if (result.find(f => f.type === "OverNight") !== undefined) {
          $('#repair_type').html(`<option value="" selected>Selecione o tipo de reparação</option><option value="undefined">Reparação no dia seguinte</option><option value="Daily">Reparação no próprio dia</option><option value="OverNight">Reparação durante a noite</option>`);
        } else{
          $('#repair_type').html(`<option value="" selected>Selecione o tipo de reparação</option><option value="undefined">Reparação no dia seguinte</option>`);
        }
      },
      error: function (xhr, ajaxOptions, thrownError) { //Add these parameters to display the required response
        console.log(xhr.status);
      }
    });

  });

  $("#repair_type").change(function () {
    if((this).value !== 'undefined') {
      $('.choose-date').hide();
    }else{
      $('.choose-date').show();
    }
  });

  $(".rep-serviced-radio").change(function () {
    $('.iphone_reparacao-div').removeClass('active');
    $(this).closest('.iphone_reparacao-div').addClass('active');
    var servicePriceData = $(this).attr('data-price');
    var serviceName = $(this).val();
    $("[data-rep-name]").html('Reparação de '+ serviceName).css('opacity', '1');
    $('[data-line]').css('opacity', '1');
    if(servicePriceData == "-") {
      $("[data-rep-price]").html("<p>Não se aplica</p>").css('opacity', '1');
      if ($(window).width() > 480) {
        $('[data-value-price]').val('O custo da reparação pretendida é de: Não se aplica');
      } else {
        $('[data-value-price]').val('O custo é de: Não se aplica');
      }
    } else {
      $("[data-rep-price]").html("<span></span><h2 class='u-margin-bottom-nil u-margin-top-nil'>" + servicePriceData + " € </h2>").css('opacity', '1');
      if ($(window).width() > 480) {
        $('[data-value-price]').val('O custo da reparação pretendida é de: ' + servicePriceData + ' €');
      } else {
        $('[data-value-price]').val('O custo é de: ' + servicePriceData + ' €'); 
      }
    }
    $('#rep_memory').html('<option selected disabled value="'+serviceName+'">'+ serviceName +'</option>');
    // 	var description = get_services_detail(servicePriceData);
    //     $('.problems_text ul').html(description);
    $('.problems_text').css('opacity', '1');
    $('.problems_text').html($(this).closest('.iphone_reparacao-div').find('[data-desc]').html());
    //     $('.iphone_reparacao-div').each(function(){
    //       if ($(this).find('[data-in]').text() == serviceName) {
    //         $(this).removeClass('disable').addClass('active');
    //         $('[data-new-text]').html($(this).find('[data-desc]').html());
    //         $('.problems_text').css('opacity', '1');
    //       }
    //     });
    $('[data-repair_list]').val(serviceName);
    if ($(window).width() < 768) {
      if (!$('[data-not-scroll]').hasClass('not-scroll')) {
        $('html, body').animate({ scrollTop: $('.hide-on-desk').offset().top}, 1000);
      }
      $('[data-not-scroll]').removeClass('not-scroll');
    }
  });

});

function get_device(os) {
  var html = "<option>-</option>";
  for(var i = 0; i < repair_values.length; i++)
    if(repair_values[i].os == os)
      html = html + "<option value='" + repair_values[i].device + "'>" + repair_values[i].device + "</option>";
  if (html == "<option>-</option>")
    return "";
  else 
    return html;
}

function get_phones(os) {
  var html = "<option>-</option>";
  for(var i = 0; i < repair_values.length; i++)
    if(repair_values[i].os == os)
      html = html + "<option value='" + repair_values[i].model + "'>" + repair_values[i].model + "</option>";
  if (html == "<option>-</option>")
    return "";
  else 
    return html;
}

function get_services(model) {
  var html = "<option>-</option>";
  for(var i = 0; i < repair_values.length; i++)
    if(repair_values[i].model == model)
      for(var j = 0; j < repair_services.length; j++)
        if(repair_values[i].service[j] != "-")
          html = html + "<option value='" + repair_values[i].service[j] + "'>" + repair_services[j] + "</option>";
  return html;
}

function get_services_detail(model) {
  var html = "";
  if(repair_services_details[model].length != 0)
    for(var i = 0; i < repair_services_details[model].length; i++)
      html = html + "<li>"+repair_services_details[model][i]+"</li>";


  return html;  
}

//function to get repair types
function get_repairs(){
  var modelSelected = $('#rep_model').val();
  if(repair_values.find(f => f.model === modelSelected) !== undefined){
    var selected = repair_values.find(f => f.model === modelSelected).repair_services;
    var listOfRepairs = [`<option value="" selected>Selecione o que precisa de reparar</option>`];
    $.each(selected, function(key, value) {
      listOfRepairs.push(`<option value='${value}'>${value}</option>`);
    });
    $('#repair_list').html(listOfRepairs);
  }
}

function get_repairs_price(){
  var modelSelected = $('#rep_model').val();
  var repairSelected = $('#repair_list').val();
  var listOfRepairs = repair_values.find(f => f.model === modelSelected).repair_services;
  var priceOfRepairs = repair_values.find(f => f.model === modelSelected).service;
  if(repair_values.find(f => f.model === modelSelected) !== undefined){
    var selected = $.inArray(repairSelected, listOfRepairs);
    $('#repairs_price').val(`O custo da reparação pretendida é de: ${priceOfRepairs[selected]}€`);
    $('#repairs_price_val').val(priceOfRepairs[selected]);
  }
}